import { createWebStorage } from 'utils/storage';

interface ProjectStorage {
  recentProjects: string[];
}

export const projectStorage = createWebStorage<ProjectStorage>().init({
  recentProjects: '_r____p',
});
